/**
 * Hierarquia de Erros de Domínio
 * Permite tratamento específico por tipo de erro
 */

export class DomainError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'DomainError';
    }
}

export class ValidationError extends DomainError {
    constructor(message: string, public readonly field?: string) {
        super(message);
        this.name = 'ValidationError';
    }
}

export class NotFoundError extends DomainError {
    constructor(entity: string, id: string) {
        super(`${entity} com ID ${id} não encontrado`);
        this.name = 'NotFoundError';
    }
}

export class BusinessRuleError extends DomainError {
    constructor(message: string) {
        super(message);
        this.name = 'BusinessRuleError';
    }
}

export class UnauthorizedError extends DomainError {
    constructor(message: string = 'Você não tem permissão para realizar esta ação') {
        super(message);
        this.name = 'UnauthorizedError';
    }
}

export class InfrastructureError extends Error {
    constructor(message: string, public readonly originalError?: Error) {
        super(message);
        this.name = 'InfrastructureError';
    }
}
